<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M15.4 15.9q-.3.3-.7 0l-.8-.8v-.7l2-2q.4-.4 0-.8l-2-2v-.7l.8-.8q.3-.3.7 0l2 2q.3.5.7 0l2-2q.5-.3.8 0l.8.8v.7l-2 2q-.4.4 0 .8l2 2v.7l-.8.8q-.4.3-.7 0l-2-2a.5.5 0 0 0-.8 0zM3 7.8a1 1 0 0 0-1 1v6.4q0 .9 1 1h2q.3 0 .6.3l3.9 3.8a1 1 0 0 0 1.7-.7V4.4a1 1 0 0 0-1.7-.7L5.6 7.5l-.7.3z"
    />
  </svg>
</template>
